import { GUIDED_RESEARCH } from 'global/constants';
import {
  StimulusLibrary,
  StimulusLibraryCreate,
} from '../shared/stimulus-library';
import {
  GUIDED_RESEARCH_TITLE,
  SettingsProps,
} from './guided-research.constants';
import GuidedResearchEditPreviewDrawer from './guided-research-edit-preview-drawer';

const GuidedResearchSettings = (props: SettingsProps) => {
  return props.properties.stimulusId ? (
    <GuidedResearchEditPreviewDrawer {...props} />
  ) : (
    <StimulusLibrary
      stimulusType={GUIDED_RESEARCH}
      componentId={props.id}
      title={GUIDED_RESEARCH_TITLE}
      canGoBack={false}
      headerActionButton={
        <StimulusLibraryCreate
          sectionId={props.sectionId}
          componentId={props.id}
          contentId={props.lessonId}
          type={GUIDED_RESEARCH}
        />
      }
      {...props}
    />
  );
};

export default GuidedResearchSettings;
